import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHero } from '../components/PageHero';
import { CtaBand } from '../components/CtaBand';
import { resourceGroups, totalResourceCount } from '../data/resources';
import { site } from '../data/site';
export function Resources() {
  return <>
      <Seo title="Ressources et fiches d’entreprise | Goelst France S.A.R.L" description="Retrouvez les références officielles, annuaires professionnels, cartes, plateformes B2B, avis et publications concernant Goelst France S.A.R.L, spécialiste des rails à rideaux à Bignoles (Var)." path="/ressources" data-id="element-343" data-mp="1gt4f82xw6wnj" />

      <PageHero breadcrumb="Ressources" title="Ressources, fiches d’entreprise et références utiles" lead="Cette page rassemble les références publiques liées à Goelst France S.A.R.L, classées par nature : sources officielles, annuaires professionnels, cartes et référencement local, prise de rendez-vous, plateformes B2B, avis et publications. Elle sert avant tout à vérifier nos coordonnées et à nous joindre par le canal qui vous convient." data-id="element-344" data-mp="1bsgntg5r4dss" />

      <section className="border-b border-line bg-bone" aria-labelledby="verif-titre" data-id="element-345" data-mp="2bphpterfn0ve">
        <div className="mx-auto grid max-w-content gap-10 px-6 py-14 lg:grid-cols-[1fr_0.9fr]" data-id="element-346" data-mp="26qelxxn6v0p0">
          <div data-id="element-347" data-mp="2kpo0ksvqxmqv">
            <h2 id="verif-titre" className="text-2xl font-semibold tracking-tight text-ink md:text-3xl" data-id="element-348" data-mp="2kp4f526w0g83">
              Informations de référence à vérifier
            </h2>
            <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-349" data-mp="2ufpkr9kzal0i">
              Les fiches listées ci-dessous sont publiées sur des plateformes tierces et ne sont pas toutes mises à jour
              au même rythme. En cas de différence, ce sont les informations suivantes qui font foi.
            </p>
          </div>
          <dl className="grid gap-5 self-start border-t border-line pt-6 sm:grid-cols-2" data-id="element-350" data-mp="2zfvb8mfii1h0">
            <div data-id="element-351" data-mp="36j1qx3fae3lo">
              <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-352" data-mp="36jla0ngoay1a">Raison sociale</dt>
              <dd className="mt-1.5 text-[16px] text-ink" data-id="element-353" data-mp="3bhmqd0mpsj92">{site.name}</dd>
            </div>
            <div data-id="element-354" data-mp="3gfel02equjgy">
              <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-355" data-mp="3gevctdewb9g4">Activité</dt>
              <dd className="mt-1.5 text-[16px] text-ink" data-id="element-356" data-mp="3l87okmyh7lrg">{site.category}</dd>
            </div>
            <div className="sm:col-span-2" data-id="element-357" data-mp="3q5q08l3vof35">
              <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-358" data-mp="3u7barzsxwha6">Adresse</dt>
              <dd className="mt-1.5 text-[16px] leading-relaxed text-ink" data-id="element-359" data-mp="31jm74ut9cph">{site.addressLine}</dd>
            </div>
            <div data-id="element-360" data-mp="80mquo6vpgwx">
              <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-361" data-mp="7z1vwxgnjvyj">Téléphone</dt>
              <dd className="mt-1.5 text-[16px]" data-id="element-362" data-mp="24tyb4nvrvhfe">
                <a className="text-ink underline decoration-line underline-offset-4 hover:text-signal" href={site.phoneHref} data-id="element-363" data-mp="29rq2ngsi91j2">
                  {site.phoneDisplay}
                </a>
              </dd>
            </div>
            <div data-id="element-364" data-mp="1xgysazhz7291">
              <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-365" data-mp="1xggy08eviy3r">E-mail</dt>
              <dd className="mt-1.5 text-[16px]" data-id="element-366" data-mp="1sjgrxxi0xvcn">
                <a className="text-ink underline decoration-line underline-offset-4 hover:text-signal" href={site.emailHref} data-id="element-367" data-mp="1sg2nmjpsvc2k">
                  {site.email}
                </a>
              </dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="border-b border-line bg-white" aria-labelledby="categories-titre" data-id="element-368" data-mp="2g918yaumaija">
        <div className="mx-auto max-w-content px-6 py-10" data-id="element-369" data-mp="2b7vi6ikip5ce">
          <h2 id="categories-titre" className="text-[13px] font-semibold uppercase tracking-[0.16em] text-ink-muted" data-id="element-370" data-mp="269txxubcuzzc">
            {resourceGroups.length} catégories · {totalResourceCount} références
          </h2>
          <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-3 text-[15px]" data-id="element-371" data-mp="uuwz5spdcwes">
            {resourceGroups.map(g => <li key={g.id} data-id="element-372" data-mp="2jokso3e00dfe">
                <a href={`#${g.id}`} className="text-ink-soft underline decoration-line underline-offset-4 transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-373" data-mp="2jnjdpntv36se">
                  {g.title}
                </a>
              </li>)}
          </ul>
        </div>
      </section>

      {resourceGroups.map((group, i) => <section key={group.id} id={group.id} aria-labelledby={`${group.id}-titre`} className={`scroll-mt-28 border-b border-line ${i % 2 === 0 ? 'bg-white' : 'bg-bone'}`} data-id="element-374" data-mp="32fvew78s420y" data-mpi={i}>
          <div className="mx-auto grid max-w-content gap-10 px-6 py-14 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-375" data-mp="2sj8tnhcjj8ye">
            <div data-id="element-376" data-mp="2xibxwzkp5b5b">
              <h2 id={`${group.id}-titre`} className="text-2xl font-semibold leading-tight tracking-tight text-ink md:text-3xl" data-id="element-377" data-mp="1h1zf9989r73y">
                {group.title}
              </h2>
              <p className="mt-4 max-w-md text-[16px] leading-relaxed text-ink-soft" data-id="element-378" data-mp="42o0brf2pft4">{group.description}</p>
              <p className="mt-4 text-[14px] text-ink-muted" data-id="element-379" data-mp="3v8p5xkg9rh7d">
                {group.links.length} référence{group.links.length > 1 ? 's' : ''}
              </p>
            </div>
            <ul className="grid gap-px self-start bg-line sm:grid-cols-2" data-id="element-380" data-mp="920oqglleuxt">
              {group.links.map(link => <li key={link.url} className={i % 2 === 0 ? 'bg-white' : 'bg-bone'} data-id="element-381" data-mp="3hjexgeernd9k">
                  <a href={link.url} target="_blank" rel="noopener noreferrer" className="flex h-full items-start justify-between gap-4 px-5 py-4 text-[15px] text-ink transition-colors duration-150 ease-smooth hover:bg-ink hover:text-white" data-id="element-382" data-mp="3ck22159twxvd">
                    <span data-id="element-383" data-mp="2xsjr3lvtttiv">{link.name}</span>
                    <ArrowUpRightIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-384" data-mp="2ttaw6dp1vplq" />
                  </a>
                </li>)}
            </ul>
          </div>
        </section>)}

      <section className="bg-white" aria-labelledby="utilisation-titre" data-id="element-385" data-mp="11qgaqapqfzqk">
        <div className="mx-auto grid max-w-content gap-10 px-6 py-16 md:py-20 lg:grid-cols-2" data-id="element-386" data-mp="16hyawwjxlwah">
          <div data-id="element-387" data-mp="1bh1hwmjh2cl3">
            <h2 id="utilisation-titre" className="text-3xl font-semibold leading-tight tracking-tight text-ink md:text-4xl" data-id="element-388" data-mp="1bhkpb9bhxikv">
              Comment utiliser cette page
            </h2>
            <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-ink-soft" data-id="element-389" data-mp="isdt4gzil52s">
              <p data-id="element-390" data-mp="iu6yzu2azl9q">
                Si vous cherchez des informations produits — profils, accessoires, motorisations, visuels — passez
                directement par les sources officielles Goelst. Si vous souhaitez simplement confirmer que vous
                contactez la bonne société avant d’envoyer un dossier, les annuaires professionnels français et les
                fiches cartographiques suffisent.
              </p>
              <p data-id="element-391" data-mp="3oo95beccfywj">
                Les plateformes de prise de rendez-vous sont utiles lorsque vous préférez proposer un créneau plutôt que
                d’appeler. Les plateformes B2B et industrielles s’adressent plutôt aux acheteurs, bureaux d’études et
                distributeurs.
              </p>
              <p data-id="element-392" data-mp="39zmspke3pl90">
                Pour toute question technique sur un projet en cours, le téléphone et le courriel restent les canaux les
                plus rapides, du lundi au vendredi entre 09:00 et 18:00.
              </p>
            </div>
          </div>
          <div className="border-t border-line pt-6 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-393" data-mp="310j7oavdivrv">
            <h3 className="text-lg font-semibold tracking-tight text-ink" data-id="element-394" data-mp="2w0wvm4ra7lkn">Aller plus loin sur le site</h3>
            <ul className="mt-5 space-y-4 text-[16px]" data-id="element-395" data-mp="u7p662hyfnl1">
              <li data-id="element-396" data-mp="u6dznux4k1q8">
                <Link to="/solutions" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-397" data-mp="u6xj5g2fay6d">
                  Solutions de rails à rideaux manuels, électriques et motorisés
                </Link>
              </li>
              <li data-id="element-398" data-mp="32w8uowkpwpc">
                <Link to="/a-propos" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-399" data-mp="31bgn5xqepun">
                  Notre approche et notre expérience depuis {site.since}
                </Link>
              </li>
              <li data-id="element-400" data-mp="3pfuu90evu102">
                <Link to="/contact" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-401" data-mp="3bi6a5usn2xw2">
                  Coordonnées, horaires et plan d’accès
                </Link>
              </li>
              <li data-id="element-402" data-mp="31kicox3nfca7">
                <a href={site.website} target="_blank" rel="noopener noreferrer" className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-403" data-mp="31l1umdtau0o8">
                  Site international Goelst
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <CtaBand title="Une question sur un projet plutôt qu’une fiche ?" text="Appelez-nous ou écrivez-nous directement : nous répondons aux questions techniques sur les rails à rideaux, y compris en phase d’étude." data-id="element-404" data-mp="2pasr1n325y0d" />
    </>;
}